import { render, staticRenderFns } from "./RetailOrd.vue?vue&type=template&id=36e26be0"
import script from "./RetailOrd.vue?vue&type=script&lang=js"
export * from "./RetailOrd.vue?vue&type=script&lang=js"
import style0 from "./RetailOrd.vue?vue&type=style&index=0&id=36e26be0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36e26be0')) {
      api.createRecord('36e26be0', component.options)
    } else {
      api.reload('36e26be0', component.options)
    }
    module.hot.accept("./RetailOrd.vue?vue&type=template&id=36e26be0", function () {
      api.rerender('36e26be0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inventory/RetailOrd.vue"
export default component.exports